"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFERRED_CONTACT_METHODS = exports.INVESTMENT_PLATFORM_INTEREST_LEVELS = void 0;
var INVESTMENT_PLATFORM_INTEREST_LEVELS;
(function (INVESTMENT_PLATFORM_INTEREST_LEVELS) {
    INVESTMENT_PLATFORM_INTEREST_LEVELS["veryInterested"] = "veryInterested";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["interested"] = "interested";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["notReally"] = "notReally";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["notAtAll"] = "notAtAll";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["dontKnow"] = "dontKnow";
})(INVESTMENT_PLATFORM_INTEREST_LEVELS = exports.INVESTMENT_PLATFORM_INTEREST_LEVELS || (exports.INVESTMENT_PLATFORM_INTEREST_LEVELS = {}));
var PREFERRED_CONTACT_METHODS;
(function (PREFERRED_CONTACT_METHODS) {
    PREFERRED_CONTACT_METHODS["email"] = "email";
    PREFERRED_CONTACT_METHODS["phone"] = "phone";
})(PREFERRED_CONTACT_METHODS = exports.PREFERRED_CONTACT_METHODS || (exports.PREFERRED_CONTACT_METHODS = {}));
//# sourceMappingURL=answers.js.map